"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ProgressIndicator.scss");
var Join_1 = require("../../../helpers/Functions/Join");
var ProgressIndicator = function (_a) {
    var testId = _a.testId, title = _a.title, numPages = _a.numPages, currentPageNum = _a.currentPageNum, className = _a.className, accessibility = _a.accessibility, isFirstElement = _a.isFirstElement;
    return (React.createElement("div", { "data-testid": testId, className: Join_1.join(styles.progressIndicatorContainer, className) },
        React.createElement("div", { role: "alert", "aria-label": accessibility, className: Join_1.join(styles.infoContainer, "flex", "rel", "text-left") },
            isFirstElement ? (React.createElement("h1", { className: Join_1.join(styles.title, "pull-left", "color-ui-black", "font-medium") }, title)) : (React.createElement("h2", { className: Join_1.join(styles.title, "pull-left", "color-ui-black", "font-medium") }, title)),
            React.createElement("span", { className: Join_1.join(styles.pagination, "absolute", "pull-right", "color-ui-dark-gray", "pad-l-xxs", "right") },
                currentPageNum,
                " of ",
                numPages)),
        React.createElement("div", { className: Join_1.join(styles.outerBar, "height-xxxs", "bg-ui-light-gray", "mar-t-xs") },
            React.createElement("div", { className: Join_1.join(styles.innerBar, "height-xxxs", "bg-att-blue"), style: { width: (currentPageNum / numPages) * 100 + "%" } }))));
};
exports.default = ProgressIndicator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ProgressIndicator/ProgressIndicator.js
// module id = 1801
// module chunks = 8